// ─── API Config ──────────────────────────────────────────────────────────────
// Values are injected at build time via REACT_APP_* environment variables.
// See .env.local / .env.stage / .env.production for per-environment values.

export const protocol = process.env.REACT_APP_PROTOCOL || 'https';
export const domain = process.env.REACT_APP_DOMAIN || 'metapath.pyramidions.co';
export const port = process.env.REACT_APP_PORT || '443';
export const apicontext = process.env.REACT_APP_APICONTEXT || 'metapath/api';

export const restbaseurl = `${protocol}://${domain}:${port}/${apicontext}`;

// ─── Encryption ──────────────────────────────────────────────────────────────
export const encryptionKey = new TextEncoder().encode("metapath");

// ─── Chat Widget ─────────────────────────────────────────────────────────────
export const chatApiUrl = process.env.REACT_APP_CHAT_API_URL || "https://chatwidgetdev.glasscase.ai";
export const chatApiKey = process.env.REACT_APP_CHAT_API_KEY || "4e54c722-9700-4d62-bb9e-a8f67247e5a1";

// ─── reCAPTCHA ───────────────────────────────────────────────────────────────
export const recaptchaConfig = {
  development: {
    siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", // Google's test key for localhost
    enabled: true,
  },
  production: {
    siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6Lf9YE0kAAAAAPv4zL_0IqT6KSzTX7P6AMTFvd1D",
    enabled: true,
  },
};

// Get current environment
export const getCurrentEnvironment = () => {
  const currentDomain = String(domain);
  if (currentDomain === "localhost" || currentDomain.includes("localhost")) {
    return "development";
  }
  return "production";
};

// Get reCAPTCHA site key based on environment
export const getRecaptchaSiteKey = () => {
  const env = getCurrentEnvironment();
  return recaptchaConfig[env].siteKey;
};

// Check if reCAPTCHA is enabled
export const isRecaptchaEnabled = () => {
  const env = getCurrentEnvironment();
  return recaptchaConfig[env].enabled;
};
